import React, { createContext, useContext, useState, useEffect } from 'react';

interface DomainConfig {
  name: string;
  logo: string;
  primaryColor: string;
  seoTitle: string;
  seoDescription: string;
}

export interface DomainContextType {
  currentDomain: string;
  domainConfig: DomainConfig;
  setDomainFromHostname: (hostname: string) => void;
}

const defaultConfig: DomainConfig = {
  name: 'Dental Health News',
  logo: '/logo.png',
  primaryColor: '#2563eb',
  seoTitle: 'Dental Health News - Latest Articles and Updates',
  seoDescription: 'Stay informed with the latest dental health news, treatments, and expert advice.',
};

const DomainContext = createContext<DomainContextType>({
  currentDomain: '',
  domainConfig: defaultConfig,
  setDomainFromHostname: () => {},
});

export const useDomain = () => useContext(DomainContext);

export const DomainProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentDomain, setCurrentDomain] = useState('');
  const [domainConfig, setDomainConfig] = useState<DomainConfig>(defaultConfig);

  const setDomainFromHostname = (hostname: string) => {
    // Remove www. if present
    const cleanHostname = hostname.replace(/^www\./, '');
    setCurrentDomain(cleanHostname);

    // Here you can add domain-specific configurations
    // For now, we'll use the default config
    setDomainConfig(defaultConfig);
  };

  useEffect(() => {
    // Set initial domain from current hostname
    setDomainFromHostname(window.location.hostname);
  }, []);

  return (
    <DomainContext.Provider value={{ currentDomain, domainConfig, setDomainFromHostname }}>
      {children}
    </DomainContext.Provider>
  );
}; 